<template>
  <div>
    <br />
    <h1>ペットオーナー情報</h1>
    <br />

    <el-form :model="form" :rules="rules" ref="form" autocomplete="off">
      <table width="100%" border="0" style="font-size: 15px; line-height: 1.5em;">
        <tr v-if="!isToVisible">
          <td>
            <el-form-item label="" prop="toName">
              <el-input
                v-model="form.toName"
                autocomplete="off"
                class="input-width">
              </el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <td>
            <el-form-item label="部屋番号" prop="roomNumber">
              <el-input v-model="form.roomNumber" autocomplete="off" :disabled="true" class="input-width"></el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <td>
            <el-form-item label="ペットオーナ氏名" prop="userName">
              <el-input v-model="form.userName" autocomplete="off" placeholder="64桁以内" maxlength="64"  @input="filterSpecialChars" class="input-width"></el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <td>
            <el-form-item label="ペットオーナ電話番号" prop="tel">
              <el-input v-model="form.tel" autocomplete="off" placeholder="半角数字11桁以内「ハイフン(-)なし」" maxlength="11" class="input-width"></el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <td>
            <el-form-item label="メールアドレス" prop="email">
              <el-input v-model="form.email" autocomplete="off" placeholder="xxx@xxx.xxx" maxlength="64" class="input-width"></el-input>
            </el-form-item>
          </td>
        </tr>

        <!-- <tr>
          <td>
            <el-form-item label="新しいパスワード" prop="password">
              <el-input 
                v-model="form.password"
                type="password"
                autocomplete="new-password"
                name="new-password"
                readonly
                @focus="($event.target.readOnly = false)"
                placeholder="半角英数字大文字小文字含む8桁"
                maxlength="8" 
                class="input-width">
              </el-input>
            </el-form-item>
          </td>
        </tr>

        <tr>
          <td>
            <el-form-item label="新しいパスワード(再入力)" prop="confirmPassword">
              <el-input
                v-model="form.confirmPassword"
                type="password"
                autocomplete="confirm-new-password"
                name="confirm-new-password"
                readonly
                @focus="($event.target.readOnly = false)"
                placeholder="半角英数字大文字小文字含む8桁"
                maxlength="8" 
                class="input-width">
              </el-input>
            </el-form-item>
          </td>
        </tr> -->
      </table>
      <br />

      <table width="100%">
        <tr>
          <td width="30%">
            <el-button type="warning" @click="updateOwnerInfo">オーナー情報修正</el-button>
          </td>
        </tr>
      </table>
      <br />
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request'; // プロジェクトのリクエストモジュールに調整
import { Message } from 'element-ui'; // element-uiのメッセージボックスをインポート

export default {
  name: 'OwnerUpdate',
  data() {
    return {
      isToVisible: false,
      form: {
        toId: '',
        toName: '',
        roomNumber: '', 
        userName: '',
        tel: '', 
        email: ''
        // password: '', 
        // confirmPassword: '', 
      },
      rules: {
        // roomNumber: [
        //   { required: true, message: '必須です。', trigger: 'blur' },
        //   { pattern: /^[a-zA-Z0-9]{1,8}$/, message: '半角英数字8桁以内で入力してください。', trigger: 'blur' },
        // ],
        userName: [
          { required: true, message: '必須です。', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[0-9]{1,11}$/, message: '半角数字11桁以内「ハイフン(-)なし」で入力してください。', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '無効なメールアドレスです。', trigger: 'blur' },
        ]
        // password: [
        //   { required: true, message: '必須です。', trigger: 'blur' },
        //   { pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9]{8}$/, message: '半角英数字大文字小文字含む8桁で入力してください。', trigger: 'blur' },
        // ],
        // confirmPassword: [
        //   { required: true, message: '必須です。', trigger: 'blur' },
        //   {
        //     validator: (rule, value, callback) => {
        //       if (value !== this.form.password) {
        //         callback(new Error('新しいパスワードと一致しません。')); 
        //       } else {
        //         callback();
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
      },
    };
  },
  created() {
    this.getOwnerInfo();
  },
  methods: {
    // オーナー情報取得
    getOwnerInfo() {
      this.loading = true;
      request('getOwnerInfo', {}).then((res) => {
        this.form.toId = res.ownerInfo.toId;
        this.form.toName = this.getToName(res.ownerInfo.toId); 
        if (this.form.toId === '00') {
          this.isToVisible = true;
        }
        this.form.roomNumber = res.ownerInfo.roomId;
        this.form.userName = res.ownerInfo.userName;
        this.form.tel = res.ownerInfo.tel;
        this.form.email = res.ownerInfo.email;
      }).finally(() => {
        this.loading = false;
      });    
    },
    // オーナー情報更新
    async updateOwnerInfo() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            tel: this.form.tel, // 電話番号
            userName: this.form.userName, // オーナー氏名
            email: this.form.email, // メールアドレス
            // userPassword: this.form.password, // パスワード
            // confirmPassword: this.form.confirmPassword, // パスワード確認
          };
          // 正しい関数呼び出し、余計な関数定義はしない
          request('updateOwnerInfo', params).then((res) => {
            Message.success(res.msg);
            this.goBoard();
          });
        }
      });
    },
    // 棟名取得
    getToName(toId) {
      const toList = JSON.parse(sessionStorage.getItem('sessionTblToInfoList')) || [];
      const toInfo = toList.find(item => item.toId === toId);
      return toInfo ? toInfo.toName : '';
    },
    // ホームページへ遷移
    goBoard() {
      this.$router.push({
        path: "/board",
        query: { manshonId: localStorage.getItem('sessionManshonId') }
      }).catch(() => {});
    },
    filterSpecialChars(value) {
      this.form.userName = value.replace(/[^\u4e00-\u9fa5\u3040-\u309f\u30a0-\u30ff\u31f0-\u31ffa-zA-Z0-9]/g, '');
    }
  },
};
</script>

<style lang="less">
h1 {
  padding-top: 10em;
  padding: 0.25em 0.5em;
  color: #494949;
  background: transparent;
  border-left: solid 5px #7db4e6;
}

th, td {
  border: solid 0px;
  padding: 10px;
}

.commonTable {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border-spacing: 0;
  border: solid 2px #778ca3;
}
.commonTable th {
  padding: 10px;
  background: #e9faf9;
  border: solid 1px #778ca3;
  border-bottom: solid 2px #778ca3;
}
.commonTable td {
  padding: 10px;
  border-left: solid 1px #778ca3;
}
.commonTable tr {
  border-top: dashed 1px #778ca3;
}

/* Responsive design for mobile */
.input-width {
  width: 100%;
}

@media (max-width: 768px) {
  h1 {
    font-size: 18px;
  }

  .input-width {
    width: 100%;  /* Ensure input fields take full width on mobile */
  }

  .el-button {
    width: 100%;  /* Make button full width on mobile */
  }
}
</style>
